import React from 'react';
import { resolveUrl } from '../driver/driverUtils';

export const DriverChipSmall = ({ d, jobs }) => {
  const porters = jobs.reduce((n, j) => n + j.crew.length, 0);
  return (
    <div className="flex items-center gap-2">
      {d.avatar_url
        ? <img src={resolveUrl(d.avatar_url)} alt={d.name} className="w-8 h-8 rounded-full object-cover border-2" style={{ borderColor: d.color }} />
        : <span className="w-8 h-8 rounded-full" style={{ background: d.color || '#94a3b8' }} />}
      <div>
        <div className="font-black text-[color:var(--mv-navy)]">{d.name}</div>
        <div className="text-[11px] text-slate-500">{jobs.length} job{jobs.length === 1 ? '' : 's'} · {porters} porter{porters === 1 ? '' : 's'}</div>
      </div>
    </div>
  );
};
